import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";
import { setJobfair } from "../jobfairSlice";
import { setJobfairList } from "../jobSlice";
import reducer from "../reducer";

// 简单uuid生成函数
function genUUID() {
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  // 返回无 '-' 的 id
  return uuid.replace(/-/g, "");
}

const Details = () => {
  const [auth, setAuth] = useState(() => {
    const raw = localStorage.getItem("auth");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        return { ...parsed, isVirtual: false };
      } catch (e) {
        return null;
      }
    }
    const virtual = localStorage.getItem("virtual_id");
    if (virtual) {
      const cleaned = virtual.replace(/-/g, "");
      if (cleaned !== virtual) localStorage.setItem("virtual_id", cleaned);
      return { id: cleaned, uuid: cleaned, isVirtual: true };
    }
    return null;
  });
  const { id } = useParams();
  const [item, setItem] = useState(0);
  const [fromScan, setFromScan] = useState(false); // 标记扫码来源
  const [state, dispatch] = React.useReducer(reducer, {
    EMPLOYER_QTY: 0,
    JOBFAIR: useSelector((state) => state.jobfair.list),
    JOBFAIRLIST: useSelector((state) => state.job.jobfair_list),
    PEOPLE: 0,
    flag: false,
    InitiateUnits1: "",
    InitiateUnits2: "",
    organizer: "",
    chengbandanwei: "",
  });
  const reduxDispatch = useDispatch();

  // 确保未登录用户有虚拟 id，并在没有 auth 时把虚拟 id 作为临时 auth
  useEffect(() => {
    if (!localStorage.getItem("auth")) {
      let virtual = localStorage.getItem("virtual_id");
      if (!virtual) {
        virtual = genUUID();
        // genUUID 已返回无 '-' 的 id，但仍然确保写入为无 '-' 的值
        const cleaned = virtual.replace(/-/g, "");
        localStorage.setItem("virtual_id", cleaned);
        virtual = cleaned;
      } else {
        const cleaned = virtual.replace(/-/g, "");
        if (cleaned !== virtual) {
          localStorage.setItem("virtual_id", cleaned);
          virtual = cleaned;
        }
      }
      setAuth({ id: virtual, uuid: virtual, isVirtual: true });
    } else {
      const raw = localStorage.getItem("auth");
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          setAuth({ ...parsed, isVirtual: false });
        } catch (e) {
          // ignore
        }
      }
    }
  }, []);

  React.useEffect(() => {
    if (fromScan) {
      // 延时2秒 发送请求
      setTimeout(() => {
        console.info("from scan, save fair journal", auth.id, id);
        if (!auth || !id) return;
        const saveFairJournal = async () => {
          const response = await fetch("/gin-api/fair/_/journal", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              relation_id: auth.id,
              reference_id: id,
              action: "浏览",
            }),
          });
          if (!response.ok) {
            console.info("failed to save fair journal");
          }
        };
        saveFairJournal();
      }, 2000);
    }
  }, [fromScan]);

  useEffect(() => {
    // 判断扫码来源（支持普通 query 和 hash 路由中的 query）
    const getParamFromUrl = (key) => {
      // 优先检查标准的 search
      const searchParams = new URLSearchParams(window.location.search);
      const val = searchParams.get(key);
      if (val) return val;
      // 检查 hash 中是否含有 query 且带有 ?
      const hash = window.location.hash || "";
      const qIdx = hash.indexOf("?");
      if (qIdx >= 0) {
        const hashQuery = hash.substring(qIdx + 1);
        const hashParams = new URLSearchParams(hashQuery);
        const hv = hashParams.get(key);
        if (hv) return hv;
      }
      return null;
    };

    const fromScanParam = getParamFromUrl("fromScan");
    const sceneParam = getParamFromUrl("scene");
    if (fromScanParam === "1" || sceneParam) {
      setFromScan(true);
    }

    if (id === "371") {
      dispatch({
        type: "set",
        payload: { key: "InitiateUnits1", value: "发起单位：黑龙江省人才服务中心" },
      });
      dispatch({
        type: "set",
        payload: { key: "InitiateUnits2", value: "（黑龙江省就业服务中心）" },
      });
      dispatch({
        type: "set",
        payload: { key: "organizer", value: "主办单位：牡丹江大学" },
      });
      dispatch({
        type: "set",
        payload: { key: "chengbandanwei", value: "承办单位：龙江学子就业平台" },
      });
    }
    if (id === "186" || id === "188" || id === "189" || id === "187" || id === "190") {
      dispatch({
        type: "set",
        payload: { key: "flag", value: true },
      });
      if (id === "186") {
        dispatch({
          type: "set",
          payload: { key: "PEOPLE", value: "1086人" },
        });
      } else if (id === "189") {
        dispatch({
          type: "set",
          payload: { key: "PEOPLE", value: "550人" },
        });
      } else if (id === "188") {
        dispatch({
          type: "set",
          payload: { key: "PEOPLE", value: "800人" },
        });
      } else if (id === "187") {
        dispatch({
          type: "set",
          payload: { key: "PEOPLE", value: "750人" },
        });
      } else if (id === "190") {
        dispatch({
          type: "set",
          payload: { key: "PEOPLE", value: "2168人" },
        });
      }
    }
    fetch(`/api/simple/bulletin/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.detail.status === "停用") {
          alert("招聘会已结束");
          history.back();
          return;
        }
        setItem(data);
        document.getElementById("content").innerHTML = data.detail.content;
        if (auth && !auth.isVirtual) {
          saveJournal({
            ref_id: auth.id,
            ref_uuid: auth.uuid,
            ref_id2: id,
            ref_uuid2: "",
            category: "浏览招聘会",
            tag: "个人用户",
          });
        }
      });
  }, [id]);

  useEffect(() => {
    // 参加招聘会的岗位和企业
    fetch(`/gin-api/complex/minip-fair-employer-job?fairId=${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (id === "277") {
          data.employerList.reverse();
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: data.employerList },
          });
          reduxDispatch(setJobfair({ list: data.employerList }));
        } else if (id === "276") {
          const arr = [];
          data.employerList.map((item) => {
            if (item.id % 2 !== 0) {
              // 判断当前元素是否为奇数
              arr.unshift(item); // 若是奇数则添加到新数组的开头位置（unshift()函数）
            } else {
              arr.push(item); // 若不是奇数则直接添加到新数组的尾部位置（push()函数）
            }
          });
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: arr },
          });
          reduxDispatch(setJobfair({ list: arr }));
        } else if (id === "278") {
          const arr1 = [];
          data.employerList.map((item) => {
            if (item.id % 2 === 0) {
              arr1.unshift(item);
            } else {
              arr1.push(item);
            }
          });
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: arr1 },
          });
          reduxDispatch(setJobfair({ list: arr1 }));
        } else if (id === "279") {
          const arr2 = [];
          data.employerList.map((item) => {
            if (item.id % 3 === 1) {
              arr2.unshift(item);
            } else {
              arr2.push(item);
            }
          });
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: arr2 },
          });
          reduxDispatch(setJobfair({ list: arr2 }));
        } else if (id === "280") {
          const arr3 = [];
          data.employerList.map((item) => {
            if (item.id % 3 === 2) {
              arr3.unshift(item);
            } else {
              arr3.push(item);
            }
          });
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: arr3 },
          });
          reduxDispatch(setJobfair({ list: arr3 }));
        } else if (id === "281") {
          for (let i = 0, len = data.employerList.length; i < len; i++) {
            const currentRandom = Number.parseInt(0.77500400906318 * (len - 1));
            const current = data.employerList[i];
            data.employerList[i] = data.employerList[currentRandom];
            data.employerList[currentRandom] = current;
          }
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: data.employerList },
          });
          reduxDispatch(setJobfair({ list: data.employerList }));
        } else if (id === "275") {
          for (let i = 0, len = data.employerList.length; i < len; i++) {
            const currentRandom = 1;
            const current = data.employerList[i];
            data.employerList[i] = data.employerList[currentRandom];
            data.employerList[currentRandom] = current;
          }
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: data.employerList },
          });
          reduxDispatch(setJobfair({ list: data.employerList }));
        } else {
          dispatch({
            type: "set",
            payload: { key: "JOBFAIR", value: data.employerList },
          });
          reduxDispatch(setJobfair({ list: data.employerList }));
        }
        dispatch({
          type: "set",
          payload: { key: "JOBFAIRLIST", value: data.jobList },
        });
        reduxDispatch(setJobfairList({ jobfair_list: data.jobList }));
      });
  }, [id]);

  return (
    <div className="container-fluid">
      <div className="card border-0 user-radius shadow my-2">
        <ToBack href="#招聘会" />
        <div className="card-header bg-transparent mx-auto">
          <h5>{item.title}</h5>
          <p>{state.InitiateUnits1}</p>
          <p style={{ marginLeft: 55 }}>{state.InitiateUnits2}</p>
          <p>{state.organizer}</p>
          <p>{state.chengbandanwei}</p>
        </div>
        <div className="card-body">
          <div id="content" className="editor-body" style={{ width: "100%" }} />
        </div>
      </div>
      {true === state.flag ? (
        <div className="card border-0 user-radius shadow my-2">
          <div className="row text-center py-2">
            <div className="col">
              参会企业
              <h5 className="text-danger">{state.JOBFAIR.length}家</h5>
            </div>
            <div className="col">
              招聘人数
              <h5 className="text-success">{state.PEOPLE}</h5>
            </div>
          </div>
        </div>
      ) : (
        <div className="card border-0 user-radius shadow my-2">
          <div className="row text-center py-2">
            <div className="col">
              参会企业
              <h5 className="text-danger">{state.JOBFAIR.length}家</h5>
            </div>
            <div className="col">
              参会岗位
              <h5 className="text-success">{state.JOBFAIRLIST.length}个</h5>
            </div>
          </div>
        </div>
      )}
      {state.JOBFAIR &&
        state.JOBFAIR.map((item) => (
          <div className="card border-0 user-radius shadow my-2" key={item.id}>
            <div className="card-header py-2 bg-transparent ">
              <h6 className="m-0">{item.name}</h6>
            </div>
            <div className="card-body py-2" style={{ fontSize: 15 }}>
              {state.JOBFAIRLIST.filter(
                (it) => it.employerId.toString() === item.id.toString(),
              ).map((it) => (
                <p key={it.id} className="my-2 pb-3">
                  <a
                    href={`#/岗位/${it.id}?fairId=${id}&u_id=${it.uuid}&employerId=${item.id}${fromScan ? "&fromScan=1" : ""}`}
                  >
                    {it.name}
                  </a>
                  &nbsp;
                  {it.salary1 === "0" && it.salary1 === "0" ? (
                    <span className="text-danger float-right">面议</span>
                  ) : (
                    <span className="text-danger float-right">
                      ￥{it.salary1}-￥{it.salary2}
                    </span>
                  )}
                </p>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default Details;
